import ScreenshotMock from "../components/ScreenshotMock";
import WealthEmpireMock from "../components/WealthEmpireMock.js";

const GamesPage = ({ navigate }) => {
  const games = [
    {
      id: "color-clash",
      title: "Color Clash",
      subtitle: "Color Flood Puzzle",
      icon: "🎨",
      color: "#FF4757",
      accent: "#FFA502",
      tags: ["Puzzle", "Strategy", "Offline"],
      desc: "A brain-teasing flood puzzle. Flood the entire board with one color in limited moves. Start from the corner and conquer the grid!",
      stats: [["4.8★","Rating"],["10K+","Downloads"],["100+","Levels"]],
      mock: "color",
      gradient: "linear-gradient(135deg, #FF475718, #FFA50210)",
    },
    {
      id: "wealth-empire",
      title: "Wealth Empire",
      subtitle: "Idle Tycoon",
      icon: "💰",
      color: "#FFD700",
      accent: "#FFA502",
      tags: ["Idle", "Tycoon", "Clicker"],
      desc: "Build your business empire from a lemonade stand to skyscrapers. Hire managers, automate income, and become a billionaire tycoon!",
      stats: [["4.7★","Rating"],["5K+","Downloads"],["50+","Businesses"]],
      mock: "wealth",
      gradient: "linear-gradient(135deg, #FFD70018, #FFA50210)",
    },
  ];

  return (
    <main style={{ paddingTop: 90 }}>
      {/* Header */}
      <section style={{ padding: "60px 5% 40px", textAlign: "center", position: "relative", overflow: "hidden" }}>
        {[
          { color: "#A855F730", left: "-5%", top: "0%", size: 400 },
          { color: "#3EAEFF20", right: "-5%", top: "20%", size: 350 },
        ].map((b, i) => (
          <div key={i} style={{
            position: "absolute", width: b.size, height: b.size, borderRadius: "50%",
            background: b.color, filter: "blur(80px)",
            left: b.left, right: b.right, top: b.top,
            pointerEvents: "none",
          }} />
        ))}
        <div style={{ position: "relative" }}>
          <span style={{ color: "#A855F7", fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase" }}>Our Library</span>
          <h1 style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(36px,5vw,60px)", marginTop: 8, marginBottom: 16 }}>
            All <span style={{ color: "#A855F7" }}>Games</span>
          </h1>
          <p style={{ color: "rgba(255,255,255,0.5)", fontSize: 16, maxWidth: 500, margin: "0 auto" }}>
            Two games live - more in the workshop. Each one designed to be genuinely fun.
          </p>
        </div>
      </section>

      {/* Games */}
      <section style={{ padding: "20px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", flexDirection: "column", gap: 60 }}>
          {games.map((game, idx) => (
            <div key={game.id} style={{
              display: "flex",
              alignItems: "center",
              gap: 60,
              flexDirection: idx % 2 === 1 ? "row-reverse" : "row",
              flexWrap: "wrap",
            }}>
              {/* Mock Preview */}
              <div style={{ flex: "0 0 auto", display: "flex", justifyContent: "center", position: "relative" }}>
                <div style={{ position: "absolute", inset: -40, background: `radial-gradient(ellipse, ${game.color}20, transparent 70%)`, borderRadius: "50%", animation: "blobFloat 5s ease-in-out infinite" }} />
                {game.mock === "color" ? <ScreenshotMock /> : <WealthEmpireMock />}
              </div>

              {/* Info */}
              <div style={{ flex: 1, minWidth: 280 }}>
                <div style={{ display: "flex", gap: 8, marginBottom: 16, flexWrap: "wrap" }}>
                  {game.tags.map(t => (
                    <span key={t} style={{ fontSize: 11, fontWeight: 700, padding: "4px 12px", borderRadius: 20, background: `${game.color}18`, color: game.color, border: `1px solid ${game.color}33` }}>{t}</span>
                  ))}
                </div>
                <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: "clamp(32px,4vw,50px)", color: game.color, marginBottom: 8, lineHeight: 1 }}>{game.title}</div>
                <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, fontWeight: 700, marginBottom: 16, textTransform: "uppercase", letterSpacing: 1 }}>{game.subtitle}</div>
                <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 16, lineHeight: 1.8, marginBottom: 28, maxWidth: 460 }}>{game.desc}</p>

                {/* Stats */}
                {/* <div style={{ display: "flex", gap: 24, marginBottom: 28, flexWrap: "wrap" }}>
                  {game.stats.map(([val, label]) => (
                    <div key={label}>
                      <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 24, color: game.color }}>{val}</div>
                      <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)" }}>{label}</div>
                    </div>
                  ))}
                </div> */}

                <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
                  <button
                    style={{
                      background: `linear-gradient(135deg, ${game.color}, ${game.accent})`,
                      color: game.color === "#FFD700" ? "#1a0a00" : "#fff",
                      border: "none", padding: "14px 28px", borderRadius: 50,
                      fontSize: 15, fontWeight: 800, fontFamily: "'Fredoka One', cursive",
                      cursor: "pointer", transition: "transform 0.2s",
                      boxShadow: `0 8px 24px ${game.color}44`,
                    }}
                    onMouseEnter={e => e.currentTarget.style.transform = "translateY(-3px) scale(1.04)"}
                    onMouseLeave={e => e.currentTarget.style.transform = ""}
                    onClick={() => navigate(`/games/${game.id}`)}
                  >
                    Learn More →
                  </button>
                  <button className="btn-secondary" style={{ fontSize: 14, padding: "13px 24px" }}
                    onClick={() => window.open("https://play.google.com/store", "_blank")}>
                    ▶ Play Store
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Coming Soon Teaser */}
      <section style={{ padding: "40px 5% 80px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto" }}>
          <div style={{
            background: "rgba(255,255,255,0.02)",
            border: "1px dashed rgba(255,255,255,0.12)",
            borderRadius: 28, padding: "48px 40px",
            textAlign: "center",
            position: "relative", overflow: "hidden",
          }}>
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, #A855F708, #3EAEFF08)", pointerEvents: "none" }} />
            <div style={{ fontSize: 56, marginBottom: 16 }}>🔮</div>
            <div style={{ fontFamily: "'Fredoka One', cursive", fontSize: 32, marginBottom: 12, color: "rgba(255,255,255,0.8)" }}>More Games Coming Soon</div>
            <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 15, maxWidth: 480, margin: "0 auto" }}>
              We're actively building new titles. Follow us on the Play Store to be the first to know when they drop.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default GamesPage;